/* eslint-disable jsx-a11y/click-events-have-key-events */

import Loader from 'Component/Loader';
import MenuItem from 'Component/MenuItem';
import {
    MenuComponent as SourceMenuComponent,
} from 'SourceComponent/Menu/Menu.component';
import {ReactElement} from 'Type/Common.type';
import {getSortedItems} from 'Util/Menu';
import {FormattedMenuItem} from 'Util/Menu/Menu.type';

import './Menu.override.style';

/** @namespace Steinkrueger/Component/Menu/Component */
export class MenuComponent extends SourceMenuComponent {
    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/only-render-in-component
    componentDidMount(): void {}

    renderTopLevel(): ReactElement {
        const { menu } = this.props;
        const categoryArray = Object.values(menu);
        const isLoading = true;

        if (!categoryArray.length) {
            return (
                <div block="Menu" elem="MainCategoriesPlaceholder">
                    <Loader isLoading={ isLoading } />
                </div>
            );
        }

        const [{ children, title: mainCategoriesTitle }] = categoryArray;
        const childrenArray = getSortedItems(Object.values(children));

        return (
            <>
                <div block="Menu" elem="MainCategories">
                    { this.renderAdditionalInformation(true) }
                    <ul
                      block="Menu"
                      elem="ItemList"
                      mods={ { type: 'main' } }
                      aria-label={ mainCategoriesTitle }
                    >
                        { childrenArray.map(this.renderFirstLevel.bind(this)) }
                    </ul>
                </div>
                { this.renderSubMenuDesktop(children) }
            </>
        );
    }

    renderAdditionalInformation(checkMobile = false): ReactElement {
        const { device } = this.props;

        if (checkMobile && !device.isMobile) {
            return null;
        }

        return (
            <>
                { this.renderStoreSwitcher() }
            </>
        );
    }

    renderFirstLevelItems(item: FormattedMenuItem): ReactElement {
        const {
            activeMenuItemsStack,
            handleSubcategoryClick,
            onCategoryHover,
            closeMenu,
            device,
        } = this.props;

        const { children, item_id } = item;
        const childrenArray = Object.values(children);
        const itemMods = { type: 'main' };

        if (childrenArray.length && device.isMobile) {
            return (
                <div
                    // eslint-disable-next-line react/jsx-no-bind
                  onClick={ (e) => handleSubcategoryClick(e, item) }
                  tabIndex={ 0 }
                  block="Menu"
                  elem="SubCatLink"
                  role="button"
                >

                    { !device.isMobile && (
                        <MenuItem
                          activeMenuItemsStack={ activeMenuItemsStack }
                          item={ item }
                          itemMods={ { ...itemMods, isExpanded: activeMenuItemsStack.includes(item_id) } }
                          onCategoryHover={ onCategoryHover }
                          closeMenu={ closeMenu }
                          isExpandable
                        />
                    ) }

                    { device.isMobile && (
                        <MenuItem
                          activeMenuItemsStack={ activeMenuItemsStack }
                          item={ item }
                          itemMods={ { ...itemMods, isExpanded: activeMenuItemsStack.includes(item_id) } }
                          closeMenu={ closeMenu }
                          isExpandable
                          isLink
                        />
                    ) }

                    { this.renderSubLevel(item, true) }
                </div>
            );
        }

        return (
            <MenuItem
              activeMenuItemsStack={ activeMenuItemsStack }
              item={ item }
              itemMods={ itemMods }
              onCategoryHover={ onCategoryHover }
              closeMenu={ closeMenu }
              isLink
            />
        );
    }

    renderSubLevel(category: FormattedMenuItem, isSecondLevel = false): ReactElement {
        const { activeMenuItemsStack } = this.props;
        const { item_id, children } = category;
        const childrenArray = getSortedItems(Object.values(children));
        const isVisible = activeMenuItemsStack.includes(item_id);
        const subcategoryMods = { type: 'subcategory' };

        return (
            <div
              block="Menu"
              elem="SubMenu"
              mods={ { isVisible } }
              key={ item_id }
            >
                <div
                  block="Menu"
                  elem="ItemList"
                  mods={ { ...subcategoryMods } }
                >
                    { childrenArray.map((item) => this.renderSubLevelItems(item, isSecondLevel)) }
                </div>
            </div>
        );
    }

    render(): ReactElement {
        return (
            <div
              block="Menu"
              elem="MenuWrapper"
            >
                { this.renderTopLevel() }
            </div>
        );
    }
}

export default MenuComponent;
